module.exports = __webpack_public_path__ + "static/instagram-adb769b360d80e54d9cebccfe8160b44.png";